import { NgModule } from '@angular/core';
import {CommonModule, NgFor} from '@angular/common';
import {CalendarComponent} from "./calendar.component";
import {FullCalendarModule} from "@fullcalendar/angular";
import {RouterModule, Routes} from "@angular/router";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {FormsModule} from "@angular/forms";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatSelectModule} from "@angular/material/select";
import {MatInputModule} from "@angular/material/input";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {PipesModule} from "../../pipes/pipes.module";


let routes: Routes = [
    { path: '', component: CalendarComponent }
]
@NgModule({
    declarations: [CalendarComponent],
    exports: [CalendarComponent],
    imports: [
        CommonModule,
        FullCalendarModule,
        RouterModule.forChild(routes),
        MatCheckboxModule,
        NgFor,
        FormsModule,
        MatFormFieldModule,
        MatSelectModule,
        MatInputModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        PipesModule,
    ]

})
export class CalendarModule { }